/**
 * TanStack Query hooks for `expo-sdk-plugin-wrapper`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	expoSdkPluginWrapperQueryKeys,
	type CreateExpoSdkPluginWrapperBody,
	type ListExpoSdkPluginWrapperResponse,
	type ExpoSdkPluginWrapperRow,
} from "./api";

export function useExpoSdkPluginWrapperList(): UseQueryResult<ListExpoSdkPluginWrapperResponse, Error> {
	return useQuery({
		queryKey: expoSdkPluginWrapperQueryKeys.list(),
		queryFn: list,
	});
}

export function useExpoSdkPluginWrapperCreate(): UseMutationResult<ExpoSdkPluginWrapperRow, Error, CreateExpoSdkPluginWrapperBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: expoSdkPluginWrapperQueryKeys.all });
		},
	});
}

export function useExpoSdkPluginWrapperDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: expoSdkPluginWrapperQueryKeys.all });
		},
	});
}
